export default __webpack_public_path__ + "static/media/product-4.b8f55bfe.JPG";